// Module
var code = "<!-- ko with: _typeData --> <!-- ko foreach: TypesView --> <div class=\"multi-select-item\" data-bind=\"css: {active: IsSelected(), disabled: IsSelected() }\"> <a data-bind=\"text: DisplayName, click: $parents[1].SelectTypeItem.bind($parents[1], $parent)\" href=\"javascript:;\"> </a> </div> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;